import React from 'react'
import DialogContent from '@material-ui/core/DialogContent';

const ModalBody = (props) => {

    const { children } = props;

    return (
        <DialogContent  dividers>
            {children}
        </DialogContent>
    )
}

export default ModalBody
